import { Link } from "react-router-dom";
import { Logo } from "./Brand";

export const AuthShell = ({ children, testid }) => (
  <div className="min-h-screen bg-[#FFF7EC] pt-[env(safe-area-inset-top)] flex flex-col">
    <header className="max-w-md w-full mx-auto px-4 h-20 flex items-center"><Link to="/"><Logo className="text-2xl" /></Link></header>
    <main className="flex-1 flex items-start sm:items-center justify-center px-4 pb-[calc(2rem+env(safe-area-inset-bottom))]">
      <div data-testid={testid} className="zn-card zn-pop w-full max-w-md p-6 sm:p-10 space-y-4">{children}</div>
    </main>
  </div>
);
